import { SHARED_SECTIONS } from "./formBaseConfig";
export const TOURIST_FORMS = {

  251: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.EMPLOYMENT,
      SHARED_SECTIONS.PASSPORT,

      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  252: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.EMPLOYMENT,
      SHARED_SECTIONS.PASSPORT,

      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  253: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.EMPLOYMENT,
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  259: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.EMPLOYMENT,
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },

  260: {
    sections: [
      SHARED_SECTIONS.Uploaded_Documents,
      SHARED_SECTIONS.PERSONAL,
      SHARED_SECTIONS.ADDRESS,
      SHARED_SECTIONS.EMPLOYMENT,
      SHARED_SECTIONS.PASSPORT,
      SHARED_SECTIONS.TRAVEL,
      SHARED_SECTIONS.DECLARATION,
    ],
  },


};
